
import React from "react";

interface ProposalComparisonTableProps {
    indexNumber: number;
    pprtyDetails: any;
    properties: any;
}


export default function ProposalComparisonTable({ indexNumber,
    pprtyDetails,
    properties }: ProposalComparisonTableProps) {
    return (
        <>
            <div
                style={{
                    width: "31.3%",
                    backgroundColor: "white",
                    // backgroundColor: "#F8F5FA",
                    borderRadius: "16px",
                    boxShadow:
                        "0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 20px 0 rgba(0, 0, 0, 0.19)",
                    minWidth: "31.3%",
                    padding: "16px",
                }}
                className="box-shadow"
            >
                <div>
                    <div>
                        <table width="100%">
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: 400,
                                        }}
                                    >
                                        <span>
                                            {" "}
                                            {
                                                pprtyDetails.propertyName
                                            }{" "}
                                            (
                                            {
                                                pprtyDetails?.floorOffered
                                            }
                                            )
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td height="6"></td>
                                </tr>
                                <tr>
                                    <td>
                                        <table
                                            width="100%"
                                            cellPadding="4"
                                            style={{
                                                border:
                                                    "dotted 2px #c1c1c1",
                                            }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        style={{
                                                            color:
                                                                "#001148",
                                                            backgroundColor:
                                                                "#D5D5D5",
                                                            width: "35%",
                                                            fontSize:
                                                                "12px",
                                                            borderRight:
                                                                "solid 1px #929292",
                                                            borderBottom:
                                                                "1px solid #929292",
                                                        }}
                                                    >
                                                        Particulars{" "}
                                                    </th>
                                                    <th
                                                        style={{
                                                            color:
                                                                "#001148",
                                                            backgroundColor:
                                                                "#D5D5D5",
                                                            fontSize:
                                                                "12px",
                                                            borderBottom:
                                                                "1px solid #929292",
                                                        }}
                                                    >
                                                        {
                                                            pprtyDetails?.floorOffered
                                                        }
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pprtyDetails.furnishingDetails.map(
                                                    (floor: {
                                                        attrName: number;
                                                        attrOptionValue: number;
                                                    }) => (
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    fontSize:
                                                                        "10px",
                                                                    color:
                                                                        "#000",
                                                                    fontWeight: 400,
                                                                    borderRight:
                                                                        "solid 1px #929292",
                                                                    borderTop:
                                                                        "solid 1px #E4E4E4",
                                                                }}
                                                            >
                                                                {
                                                                    floor?.attrName
                                                                }
                                                            </td>
                                                            <td
                                                                align="center"
                                                                style={{
                                                                    fontSize:
                                                                        "10px",
                                                                    color:
                                                                        "#5E5E5E",
                                                                    fontWeight: 700,
                                                                    borderTop:
                                                                        "solid 1px #E4E4E4",
                                                                }}
                                                            >
                                                                {
                                                                    floor?.attrOptionValue
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {properties?.length >= 4 &&
                (indexNumber + 1) % 3 === 0 &&
                properties?.length !==
                indexNumber + 1 && (
                    <div
                        style={{
                            pageBreakAfter: "always",
                            width: "100%",
                        }}
                    ></div>
                )}
        </>
    );
}
